import LogoMark from '@/assets/brand/logo-mark.svg?react';
import { brand } from '@/config/brand';
import { cn } from '@/lib/utils';

interface BrandLogoProps {
  /** mono: 어두운 표면(.dark 푸터 등)용 — 마크·워드마크를 현재 글자색 단색으로 */
  variant?: 'default' | 'mono';
  /** 워드마크 아래 슬로건 표시(큰 자리 전용) */
  tagline?: boolean;
  className?: string;
}

/**
 * 브랜드 로고 락업 — 마크(logo-mark.svg SSoT, 03_디자인/Logo.svg 원본) + 텍스트 워드마크.
 * 마크 색은 브랜드 자산 고정색(svg 내부 기본값)이며 DS 토큰 대상이 아니다(DESIGN.md 예외).
 * mono 는 `logo-mono` 유틸(styles/index.css)로 마크 변수를 currentColor 로 바꾼다.
 */
export function BrandLogo({ variant = 'default', tagline = false, className }: BrandLogoProps) {
  const mono = variant === 'mono';
  return (
    <span className={cn('inline-flex items-center gap-2.5 select-none', className)}>
      <LogoMark className={cn('h-7 w-auto', mono && 'logo-mono')} aria-hidden="true" />
      <span className="flex flex-col">
        <span className="text-xl leading-none font-bold tracking-tight">
          {brand.wordmark.primary}
          <span className={mono ? undefined : 'text-primary'}>{brand.wordmark.accent}</span>
        </span>
        {tagline && (
          <span className="mt-1.5 text-xs leading-none text-muted-foreground">{brand.slogan}</span>
        )}
      </span>
    </span>
  );
}
